module.exports = __webpack_public_path__ + "img/config_facebook.9eb57ace.svg";